import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { GrupoDescontoForm } from "../typings";

function useGrupoDesconto(id?: string) {
  return useQuery<GrupoDescontoForm, AxiosError>(
    `/v1/grupo-desconto/${id}`,
    async () => {
      const { data } = await http.get(`/v1/grupo-desconto/${id}`);

      return data;
    },
    {
      enabled: !!id
    }
  );
}

export default useGrupoDesconto;
